import { Component, EventEmitter, Output } from '@angular/core';


@Component({
  selector: 'app-home-subscribe',
  templateUrl: './home-subscribe.component.html',
  styleUrls: ['./home-subscribe.component.scss'],
  standalone:false
})
export class HomeSubscribeComponent {
  email: string ='';

  @Output() submitEmail = new EventEmitter<string>();
  onSubmit(form: any){

    if (form.invalid) return;
    this.submitEmail.emit(this.email)
  }
}
